'use client';

import React from 'react';

interface Team {
  id: string;
  name: string;
}

export interface SelectTeamsSectionProps {
  teams: Team[];
  isLoading: boolean;
  selectedTeams: string[];
  onToggleTeam: (teamId: string) => void;
}

const SelectTeamsSection: React.FC<SelectTeamsSectionProps> = ({
  teams,
  isLoading,
  selectedTeams,
  onToggleTeam,
}) => {
  if (isLoading) {
    return (
      <div
        className="flex items-center justify-center py-4 text-sm text-tertiary"
        data-testid="teams-loading"
      >
        Loading teams...
      </div>
    );
  }

  if (teams.length === 0) {
    return (
      <div
        className="flex items-center justify-center py-4 text-sm text-tertiary"
        data-testid="teams-empty"
      >
        No teams available
      </div>
    );
  }

  return (
    <div
      className="flex flex-wrap gap-2"
      role="group"
      aria-label="Team selection"
    >
      {teams.map((team) => {
        const isSelected = selectedTeams.includes(team.id);
        return (
          <button
            key={team.id}
            type="button"
            onClick={() => onToggleTeam(team.id)}
            className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
              isSelected
                ? 'border-violet-600 bg-violet-50 text-violet-700'
                : 'border-neutral-200 text-primary hover:border-neutral-300 hover:bg-neutral-50'
            }`}
            data-testid={`team-${team.id}`}
            aria-pressed={isSelected}
          >
            {team.name}
          </button>
        );
      })}
    </div>
  );
};

export default SelectTeamsSection;
